import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-tag')
export class Tag extends LitElement {

  static styles = [
    normalizeStyles,
    css`
      .tag {
        background: var(--color-base);
        border-radius: .75rem;
        color: var(--color-white);
        font-family: var(--font-family-alternative);
        font-size: .5rem;
        font-weight: var(--font-weight-strong);
        line-height: 1.5;
        padding: .15rem .4rem;
        text-transform: uppercase;
      }

      .bg-gradient--orange-pink {
        background: linear-gradient(36.4deg, var(--color-orange) 22.12%, var(--color-pink) 110.96%);
      }

      .bg-gradient--green-blue {
        background: linear-gradient(225.83deg, var(--color-blue) 1.74%, var(--color-green) 132.93%);
      }

      .bg-gradient--blue-violet {
        background: linear-gradient(225.83deg, var(--color-pink) -30.72%, var(--color-blue) 96.47%);
      }

      .bg-gradient--orange {
        background: linear-gradient(213.32deg, var(--color-dark-pink) -36.98%, var(--color-orange) 80.33%);
      }
    `
  ];

  @property()
  text: string;

  @property({attribute: 'gradient'})
  gradient = 'orange-pink';

  protected render(): unknown {
    return html`
      <span part="tag" class="tag bg-gradient--${this.gradient}">${this.text}</span>
    `;
  }
}
